/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactSegment } from '../../models/api-response-contact-segment';

export interface GetContactSegment$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
}

export function getContactSegment(http: HttpClient, rootUrl: string, params: GetContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegment>> {
  const rb = new RequestBuilder(rootUrl, getContactSegment.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactSegment>;
    })
  );
}

getContactSegment.PATH = '/v1/api/ui/contactSegment/{ref}';
